import {gql} from 'apollo-angular';

export const GET_ROOKIE_DAY_SCHOOLS = gql`
  query GetRookieDaySchools($districtId: Int!) {
    rookiedaySchools(districtId: $districtId) {
      id
      schoolName
      eventDates { id eventDay}
    }
  }
`;
